import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { REACT_APP_API_URL } from "../../env";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSendOTP = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      await axios.post(`${REACT_APP_API_URL}/api/auth/sendResetPassword-otp`, { EmailId: email });
      toast.success("OTP sent to your registered email.");
      setStep(2);
    } catch (error) {
      const message = error?.response?.data?.message || "Failed to send OTP. Try again later.";
      toast.error(message);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (otp.length !== 4) {
      toast.error("OTP should be 4 digits.");
      return;
    }

    try {
      await axios.post(`${REACT_APP_API_URL}/api/auth/verifyEmail-otp`, {
        EmailId: email,
        otp: otp,
      });
      toast.success("OTP verified. You can now reset your password.");
      setStep(3);
    } catch (error) {
      const message = error?.response?.data?.message || "Invalid OTP.";
      toast.error(message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      await axios.post(`${REACT_APP_API_URL}/api/auth/reset-password`, {
        EmailId: email,
        New_Password: newPassword,
      });

      toast.success("Password reset successfully.");
      navigate("/login");
    } catch (error) {
      const message = error?.response?.data?.message || "Failed to reset password.";
      toast.error(message);
    }
  };

  return (
    <div className="forgetPw-background-image d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="container" style={{ maxWidth: "400px" }}>
        <form
          className="p-4 rounded text-center"
          style={{ backgroundColor: "rgba(63, 61, 61, 0.7)" }}
          onSubmit={
            step === 1
              ? handleSendOTP
              : step === 2
                ? handleVerifyOTP
                : handleResetPassword
          }
        >
          <div className="d-flex justify-content-center mb-2">
            <NavLink to="/">
              <img
                src="images/logo/JTDC.png"
                style={{ width: "200px", cursor: "pointer" }}
                alt="Logo"
                loading="lazy"
              />
            </NavLink>
          </div>

          <h5 className="text-center text-white auth-page-title">
            {step === 1
              ? "Request OTP"
              : step === 2
                ? "Verify OTP"
                : "Create New Password"}
          </h5>

          {step === 1 && (
            <div className="form-group-signup" style={{ marginTop: "-30px" }}>
              <label htmlFor="email"></label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          )}

          {step === 2 && (
            <div className="form-group-signup">
              <label htmlFor="otp"></label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter OTP"
                required
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>
          )}

          {step === 3 && (
            <>
              <div className="form-group-signup position-relative">
                <label htmlFor="newPassword"></label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control pe-5"
                    placeholder="New Password"
                    required
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <span
                    className="position-absolute d-flex align-items-center"
                    style={{
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              <div className="form-group-signup mt-2">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Confirm New Password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </>
          )}

          <div className="d-flex justify-content-center m-10">
            <button
              type="submit"
              className="btn btn-block"
              style={{ backgroundColor: "#4b9f16", color: "white" }}
            >
              {step === 1
                ? "Submit"
                : step === 2
                  ? "Submit OTP"
                  : "Reset Password"}
            </button>
          </div>

          <p className="text-center mt-2 text-white">
            Back to{" "}
            <Link
              to="/login"
              style={{
                color: "#ffeb3b",
                textDecoration: "underline",
                fontStyle: "italic",
              }}
            >
              Login
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
